import React from 'react';
import Wrapper from 'ui/Wrapper';
import Button from 'ui/controls/Button';
import { Col, Row } from 'react-grid-system';

const ProductsShortcuts = (props) => {
    return (
        <Wrapper>
            <Row>
                {props.shortcutProducts.map(
                    (product) =>
                        props.VOnly && !product.isVButNotDouble() ? null : (
                            <Col key={product.id} xs={4}>
                                <Button
                                    onClick={() => props.onSelect(product)}
                                    block
                                    height="70px"
                                    width="95%"
                                    padding="5px"
                                    bg={product.color}
                                    size="x2"
                                    style={{ fontSize: '18px' }}
                                    data-test-id={product.id}
                                />
                            </Col>
                        )
                )}
            </Row>
        </Wrapper>
    );
};

export default ProductsShortcuts;
